//Envia a pessoa ao clicar no botão para o homebroker especificado no parametro da URL
import Navbar from "../components/Navbar"
export function getURLBackToPanel() {
   return (sessionStorage.getItem("url_confirm_pay"))
}
export function getURLBtnBackToPanel() {
   return (sessionStorage.getItem("url"))
}

